import { navSportsConstants } from './constants';

export const navSportsUpdate = (navbar, index) => ({
  type: navSportsConstants.SAVE,
  navbar,
  index
});
